import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=223c6ddd&scoped=true&"
var script = {}
import style0 from "./Settings.vue?vue&type=style&index=0&id=223c6ddd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223c6ddd",
  null
  
)

export default component.exports